import React, { useEffect } from "react";
import { useAppDispatch } from "../../redux/configureStore";
import OT from "@opentok/client";
import { useImmer } from "use-immer";
import { addSubscriber, removeSubscriber } from "./sessionSlice";
import { useSession } from "../api/helpers";

const useVonageSubscribers = (vonageSession?: OT.Session) => {
  const session = useSession();
  const dispatch = useAppDispatch();
  const [subscribers, setSubscribers] = useImmer<OT.Connection[]>([]);

  useEffect(() => {
    vonageSession?.on("connectionCreated", (event) => {
      if (session?.sessionId) {
        setSubscribers((subs) => subs.concat([event.connection]));
        dispatch(
          addSubscriber(session.sessionId, JSON.parse(event.connection.data)),
        );
      }
    });
    vonageSession?.on("connectionDestroyed", (event) => {
      if (session?.sessionId) {
        setSubscribers((subs) =>
          subs.filter(
            (sub) => sub.connectionId !== event.connection.connectionId,
          ),
        );
        dispatch(
          removeSubscriber(
            session.sessionId,
            JSON.parse(event.connection.data),
          ),
        );
      }
    });
    return () => {
      vonageSession?.off("connectionCreated");
      vonageSession?.off("connectionDestroyed");
    };
  }, [dispatch, session?.sessionId, setSubscribers, vonageSession]);

  return subscribers;
};

export default useVonageSubscribers;
